<div class="py-4 container-fluid erp-leave-import-page">
  <div class="erp-leave-import-page-header">
    <h4 class="mb-0 erp-leave-import-title">
     การจัดการคำขอสอนชดเชย - นำเข้าข้อมูลวันลาและไปปฏิบัติงาน
    </h4>
  </div>

  <div *ngIf="isAdmin" class="erp-leave-import-top-actions">
    <div
      class="erp-leave-import-source-switch"
      role="group"
      aria-label="เลือกแหล่งข้อมูลนำเข้า"
    >
      <button
        type="button"
        class="erp-leave-import-source-option"
        [class.active]="activeImportKind === 'erp_leave'"
        [attr.aria-pressed]="activeImportKind === 'erp_leave'"
        [disabled]="isImporting || isPublishing || isCheckingExistingData || isClearingData"
        (click)="onImportKindChange('erp_leave')"
      >
        ข้อมูลวันลา ERP
      </button>
      <button
        type="button"
        class="erp-leave-import-source-option"
        [class.active]="activeImportKind === 'official_trip'"
        [attr.aria-pressed]="activeImportKind === 'official_trip'"
        [disabled]="isImporting || isPublishing || isCheckingExistingData || isClearingData"
        (click)="onImportKindChange('official_trip')"
      >
        ข้อมูลไปปฏิบัติงาน
      </button>
    </div>

    <button
      *ngIf="canShowClearDataTestButton"
      type="button"
      class="btn btn-outline-danger erp-leave-import-clear-button"
      [disabled]="!canClearSelectedData"
      (click)="onClearData()"
    >
      {{ isClearingData ? 'กำลังล้างข้อมูล...' : 'ล้างข้อมูล (ทดสอบ)' }}
    </button>
  </div>

  <div class="erp-leave-import-card">
    <div class="erp-leave-import-card-body">
      <div class="erp-leave-import-toolbar" [formGroup]="form">
        <div class="erp-leave-import-filters">
          <div class="erp-leave-import-filter">
            <app-select
              label="เทอมการศึกษา"
              formControlName="academicTerm"
              [options]="academicTermOptions"
              [searchable]="false"
              [clearable]="false"
              inputClass="erp-leave-import-select"
              classes="mb-0"
            ></app-select>
          </div>

          <div class="erp-leave-import-filter">
            <app-select
              label="ปีการศึกษา"
              formControlName="year"
              [options]="yearOptions"
              [searchable]="false"
              [clearable]="false"
              inputClass="erp-leave-import-select"
              classes="mb-0"
            ></app-select>
          </div>
        </div>

        <div class="erp-leave-import-buttons">
          <button
            type="button"
            class="btn btn-outline erp-leave-import-outline-button"
            [disabled]="isExporting || isClearingData"
            (click)="onExportExcel()"
          >
            <img src="assets/media/icons/svg/file-down.svg" class="erp-leave-import-toolbar-icon" alt="" aria-hidden="true" />
            <span>ดาวน์โหลดแบบฟอร์ม</span>
          </button>

          <button
            type="button"
            class="btn btn-outline erp-leave-import-outline-button"
            [disabled]="isImporting || isPublishing || isCheckingExistingData || isClearingData || publicationStatusLoading() || publicationStatusError() || erpImportBlocked()"
            (click)="onImport()"
          >
            <img src="assets/media/icons/svg/file-up.svg" class="erp-leave-import-toolbar-icon" alt="" aria-hidden="true" />
            <span>{{ isCheckingExistingData ? 'กำลังตรวจสอบ...' : 'นำเข้าข้อมูล' }}</span>
          </button>

          <button
            type="button"
            class="btn btn-primary erp-leave-import-public-button"
            [disabled]="isImporting || isPublishing || isCheckingExistingData || isClearingData || publicationStatusLoading() || publicationStatusError() || publicationStatus()?.can_publish !== true"
            (click)="onPublish()"
          >
            <span>{{ publicationStatus()?.published ? 'ยืนยันข้อมูล' : (isPublishing ? 'กำลังยืนยันข้อมูล...' : 'ยืนยันข้อมูล') }}</span>
          </button>
        </div>
      </div>

      <div
        class="erp-leave-import-blocked-banner erp-leave-import-blocked-banner-success"
        role="status"
        *ngIf="publicationStatus()?.published"
      >
        {{ publicationBannerMessage }}
      </div>

      <div class="erp-leave-import-blocked-banner" role="alert" *ngIf="publicationStatusError()">
        <span class="erp-leave-import-blocked-banner-icon" aria-hidden="true">!</span>
        <span>ไม่สามารถตรวจสอบสถานะ Public ได้ จึงปิด Import และ Public ชั่วคราว</span>
        <button type="button" class="erp-leave-import-status-retry" (click)="loadPublicationStatus()">
          ลองใหม่
        </button>
      </div>

      <div
        class="erp-leave-import-publish-hint"
        role="note"
        *ngIf="publicationStatus() as status"
        [hidden]="status.published || status.has_data"
      >
        ต้องนำเข้าข้อมูลอย่างน้อย 1 รายการก่อนจึงจะ Public ได้
      </div>

      <div class="erp-leave-import-tabs-row">
        <div class="segmented-tabs erp-leave-import-tabs" role="tablist" aria-label="ข้อมูลนำเข้าวันลาและไปปฏิบัติงาน">
<button [attr.aria-selected]="activeTab() === 'leave_records'" role="tab"
            type="button"
            class="segmented-tab erp-leave-import-tab"
            [class.active]="activeTab() === 'leave_records'"
            (click)="onTabChange('leave_records')"
          >
            {{ firstTabLabel }}
          </button>
<button [attr.aria-selected]="activeTab() === 'check_results'" role="tab"
            type="button"
            class="segmented-tab erp-leave-import-tab"
            [class.active]="activeTab() === 'check_results'"
            (click)="onTabChange('check_results')"
          >
            ผลตรวจข้อมูล
          </button>
<button [attr.aria-selected]="activeTab() === 'match_results'" role="tab"
            type="button"
            class="segmented-tab erp-leave-import-tab"
            [class.active]="activeTab() === 'match_results'"
            (click)="onTabChange('match_results')"
          >
            ผลรวมข้อมูล
          </button>
        </div>

        <p
          class="erp-leave-import-role-notice"
          role="note"
          aria-label="ข้อจำกัดสิทธิ์การนำเข้าข้อมูล"
        >
          <span class="erp-leave-import-role-notice-icon" aria-hidden="true">!</span>
          {{ importRoleNotice }}
        </p>
      </div>

      <ng-template #rowIndexTemplate let-row="row">
        {{ row.sequence ?? row.order }}
      </ng-template>

      <ng-template #summaryIndexTemplate let-row="row">
        <div class="d-flex justify-content-start text-start w-100 erp-leave-import-summary-cell">
          {{ row.sequence ?? row.order }}
        </div>
      </ng-template>

      <ng-template #summaryTeacherTemplate let-row="row">
        <div class="d-flex justify-content-start text-start w-100 erp-leave-import-summary-cell">
          <div class="erp-leave-import-teacher-cell">
            <strong>{{ row.full_name }}</strong>
            <span *ngIf="row.email; else unknownPerson">
              {{ row.email }}
            </span>
            <ng-template #unknownPerson>
              <span>{{ row.person_number || '-' }} • ไม่พบผู้ใช้ในระบบ</span>
            </ng-template>
          </div>
        </div>
      </ng-template>

      <ng-template #summaryMatchCountTemplate let-row="row">
        <div class="d-flex justify-content-start text-start w-100 erp-leave-import-summary-cell">
          <span class="erp-leave-import-count-badge erp-leave-import-count-badge-success">
            {{ row.system_matched_request_count }}
          </span>
        </div>
      </ng-template>

      <ng-template #summaryUnmatchedCountTemplate let-row="row">
        <div class="d-flex justify-content-start text-start w-100 erp-leave-import-summary-cell">
          <span class="erp-leave-import-count-badge erp-leave-import-count-badge-danger">
            {{ row.system_unmatched_request_count }}
          </span>
        </div>
      </ng-template>

      <ng-template #summaryTotalCountTemplate let-row="row">
        <div class="d-flex justify-content-start text-start w-100 erp-leave-import-summary-cell">
          <span class="erp-leave-import-count-badge erp-leave-import-count-badge-neutral">
            {{ row.system_request_count }}
          </span>
        </div>
      </ng-template>

      <ng-template #summaryImportedAtTemplate let-row="row">
        <div class="d-flex justify-content-start text-start w-100 erp-leave-import-summary-cell">
          {{ formatDateTime(row.imported_at || row.created_at) }}
        </div>
      </ng-template>

      <ng-template #leaveDateTemplate let-row="row">
        {{ formatErpDateRange(row) }}
      </ng-template>

      <ng-template #erpLeaveStartDateTemplate let-row="row">
        {{ formatDate(row.erp_leave_start_date) }}
      </ng-template>

      <ng-template #erpLeaveEndDateTemplate let-row="row">
        {{ formatDate(row.erp_leave_end_date) }}
      </ng-template>

      <ng-template #erpSubmittedAtTemplate let-row="row">
        {{ formatDateTime(row.erp_submitted_at) }}
      </ng-template>

      <ng-template #erpLastUpdatedAtTemplate let-row="row">
        {{ formatDateTime(row.erp_last_updated_at) }}
      </ng-template>

      <ng-template #leaveTypeTemplate let-row="row">
        {{ row.leave_type || '-' }}
      </ng-template>

      <ng-template #usageStatusTemplate let-row="row">
        <span
          class="erp-leave-import-status-badge"
          [ngClass]="getIsActiveBadgeClass(row.is_active)"
        >
          {{ formatIsActive(row.is_active) }}
        </span>
      </ng-template>

      <ng-template #summaryActionTemplate let-row="row">
        <div class="d-flex justify-content-center w-100 erp-leave-import-summary-action">
          <button
            type="button"
            class="btn erp-leave-import-action-button datatable-view-action-button"
            [disabled]="isLoadingDetail"
            aria-label="ดูรายละเอียด"
            (click)="openSummaryDetail(row)"
          >
            <img
              src="assets/media/icons/svg/eye.svg"
              class="erp-leave-import-action-icon datatable-view-action-icon"
              alt=""
              aria-hidden="true"
            />
          </button>
        </div>
      </ng-template>

      <ng-template #comparisonIndexTemplate let-row="row">
        <span class="erp-leave-import-comparison-index">{{ row.sequence }}</span>
      </ng-template>

      <ng-template #comparisonSystemRequestTemplate let-row="row">
        <ng-container *ngIf="row.systemRequest as request; else emptyComparisonCell">
          <div class="erp-leave-import-request-line">
            <strong>{{ formatRequestTitle(request) }}</strong>
            <span>ช่วงเวลา: {{ request.leave_period_name || '-' }}</span>
          </div>
        </ng-container>
      </ng-template>

      <ng-template #comparisonErpRequestTemplate let-row="row">
        <ng-container *ngIf="row.erpRequest as erpRequest; else emptyComparisonCell">
          <div class="erp-leave-import-request-line">
            <strong>{{ formatErpLeaveDate(row) }}</strong>
          </div>
        </ng-container>
      </ng-template>

      <ng-template #comparisonOfficialTripTemplate let-row="row">
        <ng-container *ngIf="row.officialTripRequest; else emptyComparisonCell">
          <div class="erp-leave-import-request-line">
            <strong>{{ formatOfficialTripDate(row) }}</strong>
            <span>ช่วงเวลา: {{ formatLeavePeriod(row.officialTripRequest) }}</span>
          </div>
        </ng-container>
      </ng-template>

      <ng-template #comparisonLeaveDateTemplate let-row="row">
        <span class="erp-leave-import-comparison-date">{{ formatLeaveDate(row) }}</span>
      </ng-template>

      <ng-template #comparisonMakeupTeachingTemplate let-row="row">
        <span class="erp-leave-import-makeup-date-time">
          <span>{{ formatMakeupTeachingDate(row) }}</span>
          <span class="erp-leave-import-makeup-time">
            {{ formatMakeupTeachingTimeWithHours(row) }}
          </span>
        </span>
      </ng-template>

      <ng-template #comparisonStatusTemplate let-row="row">
        <span
          class="erp-leave-import-comparison-badge"
          [ngClass]="getComparisonBadgeClass(row.comparisonStatus)"
        >
          {{ row.comparisonLabel }}
        </span>
      </ng-template>

      <ng-template #emptyComparisonCell>
        <span class="erp-leave-import-comparison-empty">-</span>
      </ng-template>

      <div *ngIf="activeTab() === 'leave_records'" class="erp-leave-import-summary-panel">
        <app-datatable
          class="erp-leave-import-leave-record-datatable"
          [datasource]="leaveRecordTableDatasource"
          [columns]="leaveRecordColumns"
          [isLoading]="leaveRecordTableLoading()"
          [limit]="leaveRecordTableDatasource.limit"
          [mode]="datatableColumnMode.force"
          [showOrder]="false"
          [horizontalScrollWhenEmpty]="true"
          [externalSorting]="true"
          (sortChange)="onLeaveRecordSortChange($event)"
        ></app-datatable>

        <app-table-pagination
          [page]="leaveRecordTableDatasource.page"
          [limit]="leaveRecordTableDatasource.limit"
          [total]="leaveRecordTableDatasource.total"
          [totalPage]="leaveRecordTableDatasource.total_page"
          [offset]="leaveRecordTableDatasource.offset"
          [dataLength]="leaveRecordTableDatasource.data.length"
          [pageSizeOptions]="pageSizeOptions"
          ariaLabel="ERP leave records pagination"
          (pageChange)="onLeaveRecordPageChange($event)"
          (limitChange)="onLeaveRecordLimitChange($event)"
        ></app-table-pagination>
      </div>

      <div *ngIf="activeTab() === 'match_results'" class="erp-leave-import-summary-panel">
        <app-datatable
          class="erp-leave-import-summary-datatable"
          [datasource]="teacherTableDatasource"
          [columns]="columns"
          [isLoading]="tableLoading()"
          [limit]="teacherTableDatasource.limit"
          [mode]="datatableColumnMode.force"
          [showOrder]="false"
          [horizontalScrollWhenEmpty]="true"
          [horizontalScrollByMinWidth]="true"
          [externalSorting]="true"
          (sortChange)="onSortChange($event)"
        ></app-datatable>

        <app-table-pagination
          [page]="teacherTableDatasource.page"
          [limit]="teacherTableDatasource.limit"
          [total]="teacherTableDatasource.total"
          [totalPage]="teacherTableDatasource.total_page"
          [offset]="teacherTableDatasource.offset"
          [dataLength]="teacherTableDatasource.data.length"
          [pageSizeOptions]="pageSizeOptions"
          ariaLabel="ERP leave import results pagination"
          (pageChange)="onPageChange($event)"
          (limitChange)="onLimitChange($event)"
        ></app-table-pagination>


      </div>

      <div *ngIf="activeTab() === 'check_results'" class="erp-leave-import-summary-panel">
        <app-datatable
          class="erp-leave-import-summary-datatable"
          [datasource]="checkResultTableDatasource"
          [columns]="columns"
          [isLoading]="checkResultTableLoading()"
          [limit]="checkResultTableDatasource.limit"
          [mode]="datatableColumnMode.force"
          [showOrder]="false"
          [horizontalScrollWhenEmpty]="true"
          [horizontalScrollByMinWidth]="true"
          [externalSorting]="true"
          (sortChange)="onCheckResultSortChange($event)"
        ></app-datatable>

        <app-table-pagination
          [page]="checkResultTableDatasource.page"
          [limit]="checkResultTableDatasource.limit"
          [total]="checkResultTableDatasource.total"
          [totalPage]="checkResultTableDatasource.total_page"
          [offset]="checkResultTableDatasource.offset"
          [dataLength]="checkResultTableDatasource.data.length"
          [pageSizeOptions]="pageSizeOptions"
          ariaLabel="Import check results pagination"
          (pageChange)="onCheckResultPageChange($event)"
          (limitChange)="onCheckResultLimitChange($event)"
        ></app-table-pagination>
      </div>
    </div>
  </div>
</div>

<app-form-import-new
  modalId="erpLeaveImportDataModal"
  [title]="importModalTitle"
  dragText="ลากไฟล์ Excel มาวาง หรือคลิกเพื่อเลือกไฟล์"
  helperText="รองรับไฟล์ .xlsx"
  [isSaving]="isImporting"
  (saved)="onImportFile($event)"
></app-form-import-new>

<div
  class="modal fade erp-leave-import-detail-modal"
  id="erpLeaveImportTeacherDetailModal"
  tabindex="-1"
  aria-labelledby="erpLeaveImportTeacherDetailModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content erp-leave-import-summary-content">
      <div class="modal-header erp-leave-import-summary-header">
        <div *ngIf="selectedTeacherSummary as teacher">
          <h4 class="modal-title erp-leave-import-summary-title" id="erpLeaveImportTeacherDetailModalLabel">
            รายละเอียดผลรวมข้อมูลคำขอสอนชดเชย {{ teacher.full_name }}
          </h4>
        </div>

        <button type="button" class="btn-close" aria-label="Close" (click)="closeTeacherDetailModal()"></button>
      </div>

      <div class="modal-body erp-leave-import-summary-body" *ngIf="selectedTeacherSummary as teacher">
        <div class="erp-leave-import-summary-metrics">
          <div class="erp-leave-import-summary-metric">
            <span>รายการคำขอทั้งหมด</span>
            <strong>{{ teacher.system_request_count }}</strong>
          </div>
          <div class="erp-leave-import-summary-metric erp-leave-import-summary-metric-success">
            <span>ตรงกัน</span>
            <strong>{{ teacher.matched.length }}</strong>
          </div>
          <div class="erp-leave-import-summary-metric erp-leave-import-summary-metric-danger">
            <span>ไม่ตรงกัน</span>
            <strong>{{ getUnsuccessfulComparisonCount(teacher) }}</strong>
          </div>
        </div>

        <div
          class="erp-leave-import-all-matched"
          *ngIf="teacher.import_unmatched.length === 0 && teacher.system_unmatched.length === 0"
        >
          ข้อมูลตรงกันทั้งหมด
        </div>

        <div class="erp-leave-import-teacher-detail">
          <section class="erp-leave-import-result-section">
            <div class="erp-leave-import-result-section-header">
              <h6>ผลการเปรียบเทียบ</h6>
            </div>
            <div class="erp-leave-import-comparison-scroll">
              <app-datatable
                *ngIf="isTeacherDetailTableReady(); else comparisonTableLoading"
                class="erp-leave-import-comparison-datatable"
                [datasource]="comparisonTableDatasource"
                [columns]="comparisonColumns"
                [isLoading]="false"
                [limit]="comparisonTableDatasource.limit"
                [mode]="datatableColumnMode.standard"
                [showOrder]="false"
                [horizontalScrollWhenEmpty]="true"
                [externalSorting]="false"
                [maxVisibleRows]="comparisonTableDatasource.limit"
              ></app-datatable>
              <ng-template #comparisonTableLoading>
                <div class="erp-leave-import-comparison-loading">
                  กำลังโหลดข้อมูล...
                </div>
              </ng-template>
            </div>
            <app-table-pagination
              [page]="comparisonTableDatasource.page"
              [limit]="comparisonTableDatasource.limit"
              [total]="comparisonTableDatasource.total"
              [totalPage]="comparisonTableDatasource.total_page"
              [offset]="comparisonTableDatasource.offset"
              [dataLength]="comparisonTableDatasource.data.length"
              [pageSizeOptions]="comparisonPageSizeOptions"
              ariaLabel="ERP leave import comparison pagination"
              (pageChange)="onComparisonPageChange($event)"
              (limitChange)="onComparisonLimitChange($event)"
            ></app-table-pagination>
          </section>
        </div>
      </div>

      <div class="modal-footer erp-leave-import-summary-footer">
        <button type="button" class="btn btn-primary erp-leave-import-summary-close" (click)="closeTeacherDetailModal()">
          ปิด
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade erp-leave-import-detail-modal"
  id="erpLeaveImportCheckResultDetailModal"
  tabindex="-1"
  aria-labelledby="erpLeaveImportCheckResultDetailModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content erp-leave-import-summary-content">
      <div class="modal-header erp-leave-import-summary-header">
        <div *ngIf="selectedCheckResultSummary as summary">
          <h4 class="modal-title erp-leave-import-summary-title" id="erpLeaveImportCheckResultDetailModalLabel">
            รายละเอียดผลตรวจ{{ checkResultSourceLabel }} {{ summary.full_name }}
          </h4>
        </div>

        <button type="button" class="btn-close" aria-label="Close" (click)="closeCheckResultDetailModal()"></button>
      </div>

      <div class="modal-body erp-leave-import-summary-body" *ngIf="selectedCheckResultSummary as summary">
        <div class="erp-leave-import-summary-metrics">
          <div class="erp-leave-import-summary-metric">
            <span>รายการคำขอทั้งหมด</span>
            <strong>{{ summary.system_request_count }}</strong>
          </div>
          <div class="erp-leave-import-summary-metric erp-leave-import-summary-metric-success">
            <span>ตรงกัน</span>
            <strong>{{ summary.system_matched_request_count }}</strong>
          </div>
          <div class="erp-leave-import-summary-metric erp-leave-import-summary-metric-danger">
            <span>ไม่ตรงกัน</span>
            <strong>{{ summary.system_unmatched_request_count }}</strong>
          </div>
        </div>

        <section class="erp-leave-import-result-section">
          <div class="erp-leave-import-result-section-header">
            <h6>ผลการตรวจข้อมูลรายแถว</h6>
          </div>
          <div class="erp-leave-import-comparison-scroll">
            <app-datatable
              *ngIf="isCheckResultDetailTableReady(); else checkResultDetailLoading"
              [datasource]="checkResultDetailTableDatasource"
              [columns]="checkResultComparisonColumns"
              [isLoading]="false"
              [limit]="checkResultDetailTableDatasource.limit"
              [mode]="datatableColumnMode.force"
              [showOrder]="false"
              [horizontalScrollByMinWidth]="true"
              [horizontalScrollWhenEmpty]="true"
              [externalSorting]="false"
              [maxVisibleRows]="checkResultDetailTableDatasource.limit"
            ></app-datatable>
            <ng-template #checkResultDetailLoading>
              <div class="erp-leave-import-comparison-loading">
                กำลังโหลดข้อมูล...
              </div>
            </ng-template>
          </div>
          <app-table-pagination
            [page]="checkResultDetailTableDatasource.page"
            [limit]="checkResultDetailTableDatasource.limit"
            [total]="checkResultDetailTableDatasource.total"
            [totalPage]="checkResultDetailTableDatasource.total_page"
            [offset]="checkResultDetailTableDatasource.offset"
            [dataLength]="checkResultDetailTableDatasource.data.length"
            [pageSizeOptions]="pageSizeOptions"
            ariaLabel="Import check result detail pagination"
            (pageChange)="onCheckResultDetailPageChange($event)"
            (limitChange)="onCheckResultDetailLimitChange($event)"
          ></app-table-pagination>
        </section>
      </div>

      <div class="modal-footer erp-leave-import-summary-footer">
        <button type="button" class="btn btn-primary erp-leave-import-summary-close" (click)="closeCheckResultDetailModal()">
          ปิด
        </button>
      </div>
    </div>
  </div>
</div>

<app-confirm-dialog
  #clearDataConfirmDialog
  modalId="erpLeaveImportClearDataConfirm"
  icon="trash"
  [title]="clearDataConfirmTitle"
  [message]="clearDataConfirmMessage"
  cancelText="ยกเลิก"
  confirmText="ยืนยันล้างข้อมูล"
  [isProcessing]="isClearingData"
  (confirmed)="onConfirmClearData()"
></app-confirm-dialog>

<app-confirm-dialog
  #importSuccessDialog
  modalId="erpLeaveImportSuccess"
  icon="success"
  title="นำเข้าข้อมูลสำเร็จ"
  [message]="importSuccessMessage"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="closeImportSuccessDialog()"
></app-confirm-dialog>

<app-confirm-dialog
  #publishConfirmDialog
  modalId="erpLeaveImportPublishConfirm"
  icon="warning"
  [title]="publishConfirmTitle"
  [message]="publishConfirmMessage"
  cancelText="ยกเลิก"
  confirmText="ยืนยัน"
  [isProcessing]="isPublishing"
  (confirmed)="onConfirmPublish()"
></app-confirm-dialog>

<app-confirm-dialog
  #publishErrorDialog
  modalId="erpLeaveImportPublishError"
  icon="error"
  title="ไม่สามารถ Public ข้อมูลได้"
  [message]="publishErrorMessage"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="publishErrorDialog.close()"
></app-confirm-dialog>

<app-confirm-dialog
  #importExistingDataConfirmDialog
  modalId="erpLeaveImportExistingDataConfirm"
  icon="warning"
  [title]="existingDataTitle"
  [message]="existingDataMessage"
  cancelText="ยกเลิก"
  confirmText="นำเข้าต่อ"
  (confirmed)="onConfirmImportExistingData()"
></app-confirm-dialog>

<app-confirm-dialog
  #importCheckErrorDialog
  modalId="erpLeaveImportCheckError"
  icon="error"
  title="ไม่สามารถตรวจสอบข้อมูลเดิมได้"
  message="ไม่สามารถตรวจสอบข้อมูลวันลาเดิมในช่วงเวลาการศึกษาปัจจุบันได้ กรุณาลองใหม่อีกครั้ง"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="importCheckErrorDialog.close()"
></app-confirm-dialog>

<app-confirm-dialog
  #exportErrorDialog
  modalId="erpLeaveImportExportError"
  icon="error"
  title="ไม่สามารถดาวน์โหลดแบบฟอร์มได้"
  [message]="exportErrorMessage"
  confirmText="ปิด"
  [showCancelButton]="false"
  (confirmed)="exportErrorDialog.close()"
></app-confirm-dialog>
